/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOverwolfGameBodySeo
 */
export interface CreateOverwolfGameBodySeo {
    /**
     * 
     * @type {boolean}
     * @memberof CreateOverwolfGameBodySeo
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    metaTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    metaDescription?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateOverwolfGameBodySeo
     */
    keywords?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    ogTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    ogDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    ogImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    twitterCard?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    twitterTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    twitterDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    twitterImage?: string;
}

export function CreateOverwolfGameBodySeoFromJSON(json: any): CreateOverwolfGameBodySeo {
    return CreateOverwolfGameBodySeoFromJSONTyped(json, false);
}

export function CreateOverwolfGameBodySeoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOverwolfGameBodySeo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'metaTitle': !exists(json, 'metaTitle') ? undefined : json['metaTitle'],
        'metaDescription': !exists(json, 'metaDescription') ? undefined : json['metaDescription'],
        'keywords': !exists(json, 'keywords') ? undefined : json['keywords'],
        'ogTitle': !exists(json, 'ogTitle') ? undefined : json['ogTitle'],
        'ogDescription': !exists(json, 'ogDescription') ? undefined : json['ogDescription'],
        'ogImage': !exists(json, 'ogImage') ? undefined : json['ogImage'],
        'twitterCard': !exists(json, 'twitterCard') ? undefined : json['twitterCard'],
        'twitterTitle': !exists(json, 'twitterTitle') ? undefined : json['twitterTitle'],
        'twitterDescription': !exists(json, 'twitterDescription') ? undefined : json['twitterDescription'],
        'twitterImage': !exists(json, 'twitterImage') ? undefined : json['twitterImage'],
    };
}

export function CreateOverwolfGameBodySeoToJSON(value?: CreateOverwolfGameBodySeo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'metaTitle': value.metaTitle,
        'metaDescription': value.metaDescription,
        'keywords': value.keywords,
        'ogTitle': value.ogTitle,
        'ogDescription': value.ogDescription,
        'ogImage': value.ogImage,
        'twitterCard': value.twitterCard,
        'twitterTitle': value.twitterTitle,
        'twitterDescription': value.twitterDescription,
        'twitterImage': value.twitterImage,
    };
}


